import React from 'react';

import { cn } from '~/lib/cn';

import { ChevronIcon } from '../ChevronIcon/ChevronIcon';

interface ChevronButtonProps
  extends Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, 'className'> {
  isOpen: boolean;
}

export function ChevronButton({
  isOpen,
  type = 'button',
  ...props
}: ChevronButtonProps) {
  const chevronDirection = isOpen ? 'up' : 'down';

  return (
    <button
      type={type}
      className={cn(
        'flex size-xl items-center justify-center rounded-full',
        'transition-all duration-300 ease-out',
        'hover:bg-emphasis-strong active:bg-primary-default',
      )}
      {...props}
    >
      <ChevronIcon direction={chevronDirection} />
    </button>
  );
}

ChevronButton.displayName = 'ChevronButton';
